import { PaginatedTemplatesSearchOptions } from 'hooks/usePaginatedTemplatesSearch/usePaginatedTemplatesSearch.types';

// Config for templates list styling
const PADDING_SIZE = 16;
const COLUMN_NUM = 2;
const ROW_HEIGHT = 200;
const COLUMN_WIDTH_THRESHOLD = 1.5;
const INFINITE_SCROLL_INDEX_OFFSET = 10;

const TEMPLATE_THUMBNAIL_URL = `${import.meta.env.VITE_CDN_DOMAIN}/template/thumbnail/180/`;
const PAGE_THUMBNAIL_URL = `${import.meta.env.VITE_THUMBNAIL_BUCKET_LINK}/slideThumbnails/Templates/`;

// Config to be used when fetching the E2 templates
const ALGOLIA_TEMPLATES_SEARCH_CONFIG: PaginatedTemplatesSearchOptions = {
  fetchAllByFilter: true,
};

const TEMPLATES_LIST_CLASS = 'templates-list';
const THUMBNAIL_OVERLAY_BTN_CLASS = 'thumbnail-overlay-btn';

export {
  ALGOLIA_TEMPLATES_SEARCH_CONFIG,
  COLUMN_NUM,
  COLUMN_WIDTH_THRESHOLD,
  INFINITE_SCROLL_INDEX_OFFSET,
  PADDING_SIZE,
  PAGE_THUMBNAIL_URL,
  ROW_HEIGHT,
  TEMPLATE_THUMBNAIL_URL,
  TEMPLATES_LIST_CLASS,
  THUMBNAIL_OVERLAY_BTN_CLASS,
};
